import { SET_REMINDER_PREFERENCES } from '../constants/actionTypes';

const initialState = {
  reminderPreferences: null,
  loaded: false,
};

export default function settings(state = initialState, action) {
  switch (action.type) {
    case SET_REMINDER_PREFERENCES:
      return { ...state, reminderPreferences: action.payload, loaded: true };
    default:
      return state;
  }
}
